let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8oWxD"), load("ePOyH"), load("9IaUU")]).then(() => parcelRequire('lQ3Oi'));